import dynamic from 'next/dynamic'

export const CatalogBrandsGridBannerAsync = dynamic(
	() => import('./catalog-brands-grid-banner').then(({ CatalogBrandsGridBanner }) => CatalogBrandsGridBanner),
	{ ssr: false }
)
